document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".header__submenu li[id]");
  const mobileMenuItems = document.querySelectorAll(".mobile-navigation li[data-mega-menu]");
  const megaMenusDesktop = document.querySelectorAll(".desktop-mega-menu-column");
  const megaMenusMobile = document.querySelectorAll(".mobile-mega-menu-column");
  const prevButtons = document.querySelectorAll('.icon-prev-state');
  const closeMenuBtn = document.querySelector('#close-menu');
  const detailsElements = document.querySelectorAll('.menu-drawer__menu > li > details');
  const allSummaries = document.querySelectorAll('summary[aria-expanded]');
  const desktopParentTabs = document.querySelectorAll(".list-menu li > a[id]");
  const mobileParentTabs = document.querySelectorAll(".mobile-navigation-no-sub li > a");

  let activeTarget = null;
  let hideTimeout;

  // =============================
  // Desktop Hover Mega Menu
  // =============================

  const bindDesktopHover = (item) => {
    const id = item.id;
    const target = document.querySelector(`.desktop-mega-menu-${id}`);
    if (!target) return;

    let showTimer;

    const show = () => {
      clearTimeout(hideTimeout);
      megaMenusDesktop.forEach(el => el.classList.add("hidden"));
      target.classList.remove("hidden");
      activeTarget = target;

      document.querySelectorAll('li.hover').forEach(li => li.classList.remove('hover'));
      item.classList.add('hover'); 
    };

    const delayedHide = () => {
      hideTimeout = setTimeout(() => {
        if (activeTarget) {
          const itemId = activeTarget.dataset.megaMenu;
          const liElement = document.querySelector(`li#${itemId}`);
          if (!liElement || !liElement.classList.contains('hover')) {
            activeTarget.classList.add("hidden");
            activeTarget = null;
          }
        }
      }, 150);
    };

    // item.addEventListener("click", e => e.preventDefault());
    item.addEventListener("mouseenter", () => {
    clearTimeout(showTimer);
    showTimer = setTimeout(show, 150); 
    });
    item.addEventListener("mouseleave", () => {
      clearTimeout(showTimer);
      delayedHide();
    });
     target.addEventListener("mouseenter", show);
     target.addEventListener("mouseleave", delayedHide);
  };

  desktopParentTabs.forEach(bindDesktopHover);
  menuItems.forEach(bindDesktopHover);

  // =============================
  // Mobile Click Mega Menu
  // =============================
  const bindMobileMenuClick = (item) => {
    const id = item.dataset.megaMenu;
    const target = document.querySelector(`.mobile-mega-menu-${id}`);
    if (!target) return;

    item.addEventListener("click", function (e) {
      e.preventDefault();

      const isVisible = !target.classList.contains("hidden");

      megaMenusMobile.forEach(el => el.classList.add("hidden"));

      if (!isVisible) {
        target.classList.remove("hidden");
        activeTarget = target;
      } else {
        activeTarget = null;
      }
    });
  };
  mobileMenuItems.forEach(bindMobileMenuClick);
  if (typeof mobileParentTabs !== "undefined") {
    mobileParentTabs.forEach(bindMobileMenuClick);
  }
  // =============================
  // Mobile Prev Buttons
  // =============================
  prevButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      megaMenusMobile.forEach(el => el.classList.add("hidden"));
    });
  });

  if (closeMenuBtn) {
    closeMenuBtn.addEventListener("click", () => {
      megaMenusMobile.forEach(el => el.classList.add("hidden"));
    });
  }

  // =============================
  // Handle Details Toggle (Mobile Accordion)
  // =============================
  detailsElements.forEach(details => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        detailsElements.forEach(other => {
          if (other !== details) other.open = false;
        });
      }
    });
  });

  // =============================
  // Summary Hover (Desktop Fallback)
  // =============================
  allSummaries.forEach((summary) => {
    summary.addEventListener('mouseenter', function () {
      const parentItem = summary.closest('li');
      const targetColumn = parentItem?.querySelector('.desktop-mega-menu-column');

      if (targetColumn) {
        megaMenusDesktop.forEach(el => el.classList.add("hidden"));
        targetColumn.classList.remove('hidden');
        const megaMenuId = targetColumn.dataset.megaMenu;
        const liItem = document.querySelector(`li#${megaMenuId}`);

        if (liItem) {
          document.querySelectorAll('li.hover').forEach(li => li.classList.remove('hover'));
          liItem.classList.add('hover');
        }
      }
    });
  });
});
